import { useMemo } from 'react';

type CursorProps = {
    isDragging: boolean;
    canMoveBackward: boolean;
    canMoveForward: boolean;
};
export const useCursor = function ({ isDragging, canMoveBackward, canMoveForward }: CursorProps) {
    return useMemo(() => {
        const canMove = canMoveBackward || canMoveForward;

        if (!canMove) {
            return 'default';
        }

        return isDragging ? 'grabbing' : 'grab';
    }, [isDragging, canMoveBackward, canMoveForward]);
};
